<template>
  <div class="flex items-center my-5 md:my-0 cursor-pointer" @click="navigateBack">
    <ChevronLeftIcon class="text-brand-green w-5 h-5 mr-1" />
    <p class="text-sm">Back to documents</p>
  </div>
  <div class="flex-1 md:py-10 px-3 w-full md:max-h-screen absolute gray-background min-h-screen">
    <div
      class="flex flex-col rounded-lg shadow-sm bg-white px-5 py-5 max-w-screen-xl"
      v-if="getCurrentDocumentTemplate"
    >
      <div class="flex flex-row justify-between">
        <div class="flex flex-col">
          <h5 class="text-brand-black text-lg">
            {{ getCurrentDocumentTemplate.name || "No document name" }}
          </h5>
        </div>
        <div class="flex items-center pr-5"></div>
      </div>
    </div>
    <div class="flex items-center w-full mt-5 max-w-screen-xl" v-if="getCurrentDocumentTemplate">
      <template v-if="!isAllImageLoaded">
        <div
          tabindex="-1"
          id="modal-bg"
          class="flex items-center justify-center w-full h-screen bg-black opacity-20 top-0 left-0 fixed z-10"
        >
          <Loading class="opacity-100" />
        </div>
      </template>
      <div class="flex items-center w-full panel h-screen py-5">
        <div class="flex w-full h-full relative">
          <div class="flex flex-col w-9/12 h-full mx-auto">
            <div
              class="flex items-center parent my-1 relative"
              v-for="(file, idx) in getCurrentDocumentTemplate.attachments"
              :key="idx"
              ref="file-render"
              :id="`${file.name}`"
            >
              <template v-if="file.name.split('.').pop() === 'pdf'">
                <VuePdfEmbed
                  :source="file.url"
                  :width="getCurrentDocumentTemplate.overlay.frameWidth"
                  @rendered="getCurrentDocumentTemplate.overlay[file.name].loaded = true"
                  :disableAnnotationLayer="true"
                />
              </template>
              <template v-else>
                <img
                  :src="file.url"
                  :ref="`rendered-${file.name}`"
                  :style="{
                    'max-width': 'none',
                    width: `${getCurrentDocumentTemplate.overlay.frameWidth}px`
                  }"
                  @load="getCurrentDocumentTemplate.overlay[file.name].loaded = true"
                />
              </template>
              <template
                v-if="
                  getCurrentDocumentTemplate.overlay[file.name] &&
                  getCurrentDocumentTemplate.overlay[file.name].fields &&
                  getCurrentDocumentTemplate.overlay[file.name].loaded
                "
              >
                <DocumentDraggableField
                  :field="mapperData"
                  mode="input"
                  @set-field="handleInput($event, mapperData)"
                  :active="mapperData.active"
                  @activated="mapperData.active = true"
                  @deactivated="mapperData.active = false"
                  :id="`${file.name}-field-${idx}`"
                  :ref="`${file.name}-field-${idx}`"
                  v-for="(mapperData, idx) in getCurrentDocumentTemplate.overlay[file.name].fields"
                  :key="`draggable-${file.name}-${idx}`"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VuePdfEmbed from "vue-pdf-embed"

import { mapGetters } from "vuex"
import { DOCUMENT_TEMPLATE_GET } from "@/store/types"
import { ChevronLeftIcon } from "@heroicons/vue/outline"

export default {
  components: {
    VuePdfEmbed,
    ChevronLeftIcon
  },
  computed: {
    ...mapGetters(["isDocumentTemplateLoading", "getCurrentDocumentTemplate"]),
    isAllImageLoaded() {
      if (!this.getCurrentDocumentTemplate) {
        return false
      }

      const loaded = Object.keys(this.getCurrentDocumentTemplate.overlay)
        .map((key) => {
          return this.getCurrentDocumentTemplate.overlay[key].loaded
        })
        .filter(Boolean)
      return loaded.length === Object.keys(this.getCurrentDocumentTemplate.attachments).length
    }
  },
  mounted() {
    const { id } = this.$route.params
    this.id = id

    this.loadDocumentTemplate()
  },
  data() {
    return {
      id: ""
    }
  },
  methods: {
    loadDocumentTemplate() {
      const { id } = this
      this.$store.dispatch(DOCUMENT_TEMPLATE_GET, { id })
    },
    navigateBack() {
      this.$router.push({ name: "dashboard_documents" })
    }
  }
}
</script>
<style scoped>
.panel {
  max-height: 80vh;
  overflow-y: scroll;
}
@media (max-width: 768px) {
  .panel {
    max-height: 100vh;
  }
}
</style>
